import { useEffect, useRef } from 'react';
import { useApp } from '../../context/AppContext.jsx';
import DateUtils from '../../lib/dashboard/dateUtils.js';
import { Dashboard } from './Dashboard.jsx';
import { UploadZone } from './UploadZone.jsx';

export function MainContent() {
  const {
    hasDashboard,
    structName,
    pageSubtitle,
    stats,
    setManageOpen,
    handleExportPdf,
    exportingPdf,
    warning,
    setWarning,
    loadCSV
  } = useApp();

  const fileRef = useRef(null);

  useEffect(() => {
    if (!warning) return;
    const delay = warning.type === 'success' ? 4000 : 6000;
    const t = setTimeout(() => setWarning(null), delay);
    return () => clearTimeout(t);
  }, [warning, setWarning]);

  const warningStyle = warning?.type === 'success'
    ? { background: '#D1FAE5', borderColor: '#10B981', color: '#065F46' }
    : { background: '#FEF3C7', borderColor: '#F59E0B', color: '#92400E' };

  return (
    <main className="main">
      <div className="print-header" id="printHeader" style={{ display: 'none' }}>
        <div>
          <div className="ph-title" id="printTitle">
            {`Rapport Suivi du Temps — ${structName}`}
          </div>
          <div className="ph-sub" id="printSub">
            {stats?.dateRange?.start
              ? `Période : ${DateUtils.formatDate(stats.dateRange.start, 'DD/MM/YYYY')} au ${DateUtils.formatDate(stats.dateRange.end, 'DD/MM/YYYY')}`
              : 'Période : —'}
          </div>
        </div>
        <div style={{ fontSize: 10, color: '#888' }} id="printDate">
          {`Généré le ${DateUtils.formatDate(DateUtils.today(), 'DD/MM/YYYY')}`}
        </div>
      </div>

      <div className="page-header">
        <div>
          <h1>{structName}</h1>
          <div className="subtitle">{pageSubtitle}</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            type="button"
            className="btn-pdf"
            style={{ background: 'transparent', color: 'var(--accent)', border: '1px solid var(--border)' }}
            onClick={() => setManageOpen(true)}
          >
            Collaborateurs
          </button>
          <button
            type="button"
            className="btn-pdf"
            id="btnPDF"
            disabled={exportingPdf || !hasDashboard}
            onClick={handleExportPdf}
          >
            {exportingPdf ? 'Génération en cours…' : 'Exporter PDF'}
          </button>
        </div>
      </div>

      <input
        ref={fileRef}
        type="file"
        accept=".csv"
        style={{ display: 'none' }}
        onChange={(e) => {
          loadCSV(e.target.files?.[0]);
          e.target.value = '';
        }}
      />

      {!hasDashboard && <UploadZone onPick={() => fileRef.current?.click()} />}

      {warning && (
        <div
          id="unmatchedWarning"
          style={{
            display: 'block',
            marginBottom: 14,
            padding: '12px 16px',
            border: '1px solid',
            borderRadius: 8,
            fontSize: 13,
            lineHeight: 1.6,
            ...warningStyle
          }}
        >
          {warning.message}
        </div>
      )}

      {hasDashboard ? (
        <Dashboard />
      ) : (
        <div className="no-data">📊 Importez un fichier CSV pour commencer</div>
      )}
    </main>
  );
}


